import api from './api';

const BASE = '/moncash';

export default {
  list: (params = {}) =>
    api.get(BASE, { params: { functionCode: 'MONCASH_VIEW', ...params } }).then(r => r.data),

  operators: () =>
    api.get(`${BASE}/operators`, { params: { functionCode: 'MONCASH_VIEW' } }).then(r => r.data),

  get: (id) =>
    api.get(`${BASE}/${id}`, { params: { functionCode: 'MONCASH_VIEW' } }).then(r => r.data),

  create: (data) =>
    api.post(BASE, { ...data, functionCode: 'MONCASH_CREATE' }).then(r => r.data),

  update: (id, data) =>
    api.put(`${BASE}/${id}`, { ...data, functionCode: 'MONCASH_UPDATE' }).then(r => r.data),

  remove: (id) =>
    api.delete(`${BASE}/${id}`, { data: { functionCode: 'MONCASH_DELETE' } }).then(r => r.data),
};
